<template>
    <div class="h-full bg-gray-800">
        <!-- Conditionally show the mainnavbar if the current route is not LoginView -->
        <main-navbar v-if="!isPublicRoute"></main-navbar>
        <!-- The navbar (with its theme switch) is hidden on the public pages -->
        <theme-toggle v-else class="fixed top-4 right-4 z-40" />

        <!-- The router-view will render the appropriate component based on the current route -->
        <router-view></router-view>

        <!-- Phones in landscape: the layout is portrait-only, so ask to rotate back -->
        <div class="rotate-overlay" role="alert">
            <span class="material-symbols-outlined">screen_rotation</span>
            <p>{{ $t('common.rotateToPortrait') }}</p>
        </div>
    </div>
</template>

<script>
import MainNavbar from './components/common/MainNavbar.vue';
import ThemeToggle from './components/common/ThemeToggle.vue';

export default {
    name: 'App',
    components: {
        MainNavbar,
        ThemeToggle
    },
    data() {
        return { };
    },
    computed: {
        isPublicRoute() {
            return ['login', 'forgotuser', 'newuser', 'resetpassword'].includes(this.$route.name);
        }
    },
    mounted() {
        // Browsers only honor this in fullscreen/installed-app mode, so it's best effort; the
        // overlay below covers the regular browser case.
        window.screen?.orientation?.lock?.('portrait').catch(() => {});
    },
    methods: { }
};
</script>

<style>
/* Global styles for the entire application */
.rotate-overlay {
    display: none;
}

/* Touch devices that are short in landscape = phones (tablets and desktops are unaffected) */
@media (orientation: landscape) and (max-height: 500px) and (pointer: coarse) {
    .rotate-overlay {
        position: fixed;
        inset: 0;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        background-color: rgb(var(--c-gray-800) / 1);
        color: rgb(var(--c-gray-200) / 1);
        text-align: center;
    }
}
</style>
